import * as stylex from "@stylexjs/stylex";
import { localStyles } from "./site-footer-brand.styles";
import { SiteFooterSocialLinks } from "./site-footer-social-links";
import type {
  SiteFooterSocialLink,
  SiteFooterLinkRenderer,
} from "./site-footer-types";

export type SiteFooterBrandProps = {
  readonly homeHref: string;
  readonly brand: { readonly markSrc: string; readonly wordmarkSrc: string };
  readonly socialItems: readonly SiteFooterSocialLink[];
  readonly renderLink: SiteFooterLinkRenderer;
};

export function SiteFooterBrand({
  homeHref,
  brand,
  socialItems,
  renderLink,
}: SiteFooterBrandProps) {
  return (
    <div {...stylex.props(localStyles.bottom)}>
      <div {...stylex.props(localStyles.brand)}>
        {renderLink({
          href: homeHref,
          "aria-label": "Softmax home",
          ...stylex.props(localStyles.brandLink),
          children: (
            <>
              <img
                alt="Softmax brandmark"
                src={brand.markSrc}
                {...stylex.props(localStyles.brandmark)}
              />
              <img
                alt="Softmax"
                src={brand.wordmarkSrc}
                {...stylex.props(localStyles.wordmark)}
              />
            </>
          ),
        })}
      </div>
      <div {...stylex.props(localStyles.motto)}>
        <p {...stylex.props(localStyles.quote)}>May we all find alignment</p>
        <div {...stylex.props(localStyles.attribution)}>
          <p {...stylex.props(localStyles.attributionText)}>— Softmax, 2026</p>
        </div>
      </div>
      <SiteFooterSocialLinks socialItems={socialItems} />
    </div>
  );
}
